import { createAction } from '../../utils/redux/createAction';

const actionsScope = 'dashboard/change-paid-status-modal';

export const DASHBOARD_CHANGE_PAID_STATUS = {
  OPEN: `${actionsScope}/open`,
  CLOSE: `${actionsScope}/close`,
};

export const dashboardChangePaidStatusActions = {
  open: createAction(DASHBOARD_CHANGE_PAID_STATUS.OPEN),
  close: createAction(DASHBOARD_CHANGE_PAID_STATUS.CLOSE),
};

const initialState = {
  opened: false,
  appointment: {},
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case DASHBOARD_CHANGE_PAID_STATUS.OPEN: {
      return {
        ...state,
        opened: true,
        appointment: payload,
      };
    }

    case DASHBOARD_CHANGE_PAID_STATUS.CLOSE: {
      return { ...initialState };
    }

    default: {
      return state;
    }
  }
};



// WEBPACK FOOTER //
// ./src/redux/dashboard/change-paid-status-modal.js